module.exports = __webpack_public_path__ + "media/accessories/white_bg_sd300_printer-1a3e42ad.png";